<script setup lang="ts">
/* Stores */
import { useUserStore } from '@/store/user/user'

/* Types */
import { Rank } from '@/api/modules/site/site.types'

type Props = {
  ranksList: Rank[]
}
defineProps<Props>()

const userStore = useUserStore()

const currentUserRank = computed(() => userStore.statistics?.rank)
</script>

<template>
  <table class="bonus-table">
    <tbody>
      <tr
        v-for="rank in ranksList"
        :key="rank.rank"
        class="bonus-table__row"
        :class="{
          'bonus-table__row--active': rank.rank === currentUserRank,
        }"
      >
        <td class="bonus-table__cell">{{ rank.rank }} ранг</td>
        <td class="bonus-table__cell">{{ rank.description }}</td>
        <td class="bonus-table__cell">{{ rank.value }}%</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.bonus-table {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  border-spacing: 0 16px;

  &__row {
    &--active {
      color: $primary;
      background: $primary-background;
      :deep(td:first-child) {
        border-radius: 6px 0 0 6px;
      }
      :deep(td:last-child) {
        border-radius: 0 6px 6px 0;
      }
    }
  }

  &__cell {
    padding: 5px 10px;
    &:first-child {
      font-weight: 800;
    }
  }
}
</style>
